import { useAuthenticateStore } from '@/stores/authentication'
import { createBaseHttpClient } from '@/http/base-client'
import { AxiosError } from 'axios'
import Swal from 'sweetalert2'
import { useRouteFilterStore } from '@/stores/use-route-filter-store'

const client = createBaseHttpClient()

client.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status !== 401) {
      if (error.config?.method === 'get' && error.response?.status === 403) {
        window.location.reload()
      }
      return Promise.reject(error)
    }

    useAuthenticateStore.getState().forceSetAuthState('unauthenticated')

    const adminUser = useAuthenticateStore.getState().user
    if (window.location.pathname.startsWith('/portal') && adminUser) {
      notifySessionExpired('/logout', '#0341fc')
    }

    return Promise.reject(error)
  }
)

const notifySessionExpired = (
  path: string,
  buttonColor: string = '#0ea053'
) => {
  void Swal.fire({
    title: 'Uw sessie is verlopen. Log opnieuw in.',
    confirmButtonText: 'OK',
    allowOutsideClick: false,
    icon: 'warning',
    confirmButtonColor: buttonColor
  }).then((result) => {
    if (result.isConfirmed) {
      useAuthenticateStore.getState().logout()
      useRouteFilterStore.getState().reset()
      window.location.replace(path)
      window.location.reload()
    }
  })
}

export default client
